import type { NumberInputProps } from '@ksyos/design-system/dist/components/number-input';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { OmittedFormGroupFieldProps } from './FormGroup';

export interface NumberInputFieldProps extends NumberInputProps {
    errorArgs?: Record<string, string> | string[];
    onDoValidate?: () => Promise<void>;
}

export function computeNumberInputProps(properties: NumberInputFieldProps): NumberInputProps {
    return {
        error:
            properties.error && (properties.value === null || properties.value === undefined)
                ? getValidationErrorTranslation('any_empty')
                : getValidationErrorTranslation(properties.error, properties.errorArgs),
        isDisabled: properties.isDisabled,
        label: properties.label,
        maximumFractionDigits: properties.maximumFractionDigits,
        onChange: async (value) => {
            if (properties.onChange) {
                properties.onChange(value);
            }
            if (properties.onDoValidate) {
                await properties.onDoValidate();
            }
        },
        size: properties.size,
        useGrouping: properties.useGrouping,
        value: properties.value,
    };
}

export type NumberInputFormGroupFieldProps = OmittedFormGroupFieldProps & NumberInputFieldProps;
